<template>
  <div class="DropdownGptSharingItem">
    <div class="DropdownGptSharingItem__icon-container">
      <UIIcon
        :name="icon"
        class="DropdownGptSharingItem__icon"
        :class="{
          'DropdownGptSharingItem__icon--default-color': icon === 'lock',
        }"
      />
    </div>

    <div class="DropdownGptSharingItem__info">
      <div class="DropdownGptSharingItem__info-label">
        {{ label }}
      </div>

      <p class="DropdownGptSharingItem__description">
        {{ description }}
      </p>
    </div>

    <div v-if="isSelected" class="DropdownGptSharingItem__selected-container">
      <UIIcon class="DropdownGptSharingItem__selected-icon" name="check" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { IIcons } from '@/views/components/ui/icons/types'
import UIIcon from '@/views/components/ui/icons/UIIcon.vue'

defineProps<{
  label: string
  description: string
  icon: IIcons
  isSelected?: boolean
}>()
</script>

<style scoped lang="scss">
.DropdownGptSharingItem {
  display: flex;
  border-radius: 4px;
  cursor: pointer;
  gap: 0.5rem;
  position: relative;
  width: 100%;

  .DropdownGptSharingItem__icon-container {
    background-color: $color-white;
    border-radius: 50%;
    border: 1px solid $color-neutral-10;
    width: 2rem;
    height: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .DropdownGptSharingItem__icon {
    --size: 1.25rem;
    &:not(.DropdownGptSharingItem__icon--default-color) {
      --color: #{$color-primary-30};
    }
  }

  .DropdownGptSharingItem__info-label {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: $color-neutral-140;
    font-weight: 400;
  }

  .DropdownGptSharingItem__label {
    font-weight: 400;
  }

  .DropdownGptSharingItem__description {
    @include font-size-12px;
    color: $color-neutral-80;
    display: inline-block;
    align-items: center;
    text-align: justify;
  }

  .DropdownGptSharingItem__selected-container {
    position: absolute;
    top: 0;
    right: 0;
    background-color: $color-primary-40;
    width: 1rem;
    min-width: 1rem;
    height: 1rem;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .DropdownGptSharingItem__selected-icon {
    --color: #{$color-white};
    --size: 0.5rem;
  }
}
</style>
